import Config from '../../Config/Config';

const currency = Config.get('app.currency');
const locale = Config.get('app.locale');

export const formatAmount = (amount) => {
    return new Intl.NumberFormat(locale, { style: 'currency', currency: currency }).format(amount);
};
